
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { CheckCircle } from 'lucide-react';

interface SuccessMessageProps {
  userRole: 'psychologist' | 'patient';
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ userRole }) => {
  return (
    <div className="py-6">
      <Alert>
        <CheckCircle className="h-4 w-4" />
        <AlertTitle>Solicitação enviada com sucesso!</AlertTitle>
        <AlertDescription>
          {userRole === 'psychologist' 
            ? 'O paciente receberá uma notificação para confirmar o novo horário.'
            : 'O psicólogo receberá uma notificação para confirmar o novo horário.'}
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default SuccessMessage;
